import * as z from "zod";
import { userFacingError } from "../authorization";
import { connectorsByIdentifier } from "../connectors";
import { getAuthorizationItem } from "../connectors/authorization";
import { mutator } from "./mutator";

export const startConnectorAuthorizationSchema = z.object({
  connectedAppId: z.string(),
  attemptId: z.string().min(1).max(128),
  email: z.email().max(320),
});

export const completeConnectorAuthorizationSchema = z.object({
  connectedAppId: z.string(),
  attemptId: z.string().min(1).max(128),
});

export const startConnectorAuthorization = mutator({
  description:
    "Starts setting up a connector by requesting a verification code.",
  interactionType: "update",
  schema: startConnectorAuthorizationSchema,
  resolve: { app: { kind: "connectedApp", from: "connectedAppId" } },
  permissions: [
    { permission: "connected_app:write", scopeId: ({ args }) => args.app.id },
  ],
  fn: async ({ tx, args: { app, attemptId, email } }) => {
    if (!getAuthorizationItem(connectorsByIdentifier[app.identifier]))
      throw userFacingError(
        "This connector doesn’t support code verification."
      );
    if (app.configuration.connectorAuthorizationId === attemptId)
      throw userFacingError("Start a new authorization attempt.");
    await tx.mutate.connectedApps.update({
      id: app.id,
      configuration: {
        ...app.configuration,
        connectorAuthorizationId: attemptId,
        connectorAuthorizationEmail: email,
        connectorAuthorizationStatus: "registering",
        connectorAuthorizationCode: "",
        connectorAuthorizationUrl: "",
        connectorAuthorizationError: "",
      },
    });
  },
});

export const completeConnectorAuthorization = mutator({
  description: "Checks whether the user has approved connector access.",
  interactionType: "update",
  schema: completeConnectorAuthorizationSchema,
  resolve: { app: { kind: "connectedApp", from: "connectedAppId" } },
  permissions: [
    { permission: "connected_app:write", scopeId: ({ args }) => args.app.id },
  ],
  fn: async ({ tx, args: { app, attemptId } }) => {
    if (
      !getAuthorizationItem(connectorsByIdentifier[app.identifier]) ||
      app.configuration.connectorAuthorizationId !== attemptId ||
      app.configuration.connectorAuthorizationStatus !== "awaitingApproval"
    )
      throw userFacingError("Start a new connector authorization attempt.");
    await tx.mutate.connectedApps.update({
      id: app.id,
      configuration: {
        ...app.configuration,
        connectorAuthorizationStatus: "checking",
        connectorAuthorizationError: "",
      },
    });
  },
});
